<script setup>
import LicensePlateInputForm from '@/Components/LicensePlateInputForm.vue';
import { computed } from 'vue';

const props = defineProps({
    variant: {
        type: String,
        default: 'small', // 'small' or 'big'
        validator: (value) => ['small', 'big'].includes(value)
    },
    title: {
        type: String,
        default: 'Vul je kenteken nu in'
    },
    subtitle: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['submit']);

function handleSubmit(form) {
    emit('submit', form);
}
</script>

<template>
    <div class="w-full mx-auto max-w-7xl px-4 sm:px-6 2xl:px-0 my-8">
        <div :class="[variant === 'big' ? 'relative p-4 md:p-8' : 'bg-brightorange p-4', 'rounded-xl overflow-hidden']">
            <div v-if="variant === 'big'" class="absolute inset-0 w-full h-full -z-10">
                <img src="/public/img/license_plate_bg_large.webp" alt="Klik tik verkocht" class="w-full h-full object-cover object-center" />
                <div class="absolute inset-0 bg-gradient-to-b from-lessbrightorange/25 to-lessbrightorange/85"></div>
            </div>
            
            <div :class="[variant === 'big' ? 'flex-col md:flex-row' : 'justify-center items-center flex-row flex-wrap' , 'flex md:justify-between gap-4']">
                <div>
                    <h2 :class="[variant === 'big' ? 'text-4xl md:text-5xl lg:text-6xl max-w-lg' : 'text-xl sm:text-2xl md:text-3xl', 'font-bold text-shadow text-white text-left']">{{ title }}</h2>
                    <p v-if="subtitle" :class="[variant === 'big' ? 'max-w-lg' : '', 'text-white text-sm md:text-base mt-2 text-shadow']">{{ subtitle }}</p>
                </div>
                <LicensePlateInputForm
                    buttonText="Verder" 
                    :buttonColor="variant === 'big' ? 'secondary' : 'secondary'"
                    :formClasses="variant === 'big' ? 'flex flex-row md:flex-col gap-2 md:gap-4 lg:justify-end' : 'flex flex-row gap-2 md:gap-4 md:justify-end'"
                    :inputClasses="'flex flex-row w-auto sm:w-72 md:w-80 h-12 sm:h-14 md:h-16'"
                    :buttonClasses="'px-6 sm:px-8 md:px-10 sm:h-14 md:h-16'"
                    :errorClasses="'text-white text-sm mt-2 p-2 text-right rounded-md w-full md:w-auto relative z-10'"
                    @submit="handleSubmit"
                />
            </div>
        </div>
    </div>
</template>
